import PaymentRefBg from "../../../assets/icons/payment-ref-bg.jpg";
import { ReactComponent as PolygonEnt } from "../../../assets/icons/polygonEnt.svg";

const PaymentReferencesHubSection = () => {
  return (
    <div className="px-2">
      <section className="w-full mx-auto p-3 text-left bg-[#F2F4F7] rounded-[16px] border border-[#D0D5DD]">
        <div
          className=" rounded-[12px] p-[1px] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${PaymentRefBg})` }}
        >
          {/* Inner card */}
          <div className=" w-full rounded-[12px] bg-transparent px-4 py-5 md:px-10 md:py-8 flex flex-col md:flex-row md:justify-between gap-6 md:gap-10">
            {/* Left content */}
            <div className="flex-1 w-full md:w-1/2 max-w-[460px]">
              <h2 className="text-white text-2xl md:text-[32px] font-semibold mb-3 leading-tight">
                What is the Payment
                <br className="hidden md:block" /> References Hub?
              </h2>

              <p className="text-[14px] md:text-[14px] text-white/70 leading-relaxed max-w-xl">
                A simple, WhatsApp-powered system for businesses to share genuine
                payment experiences and strengthen credit decisions across the
                trade ecosystem.
              </p>
            </div>

            {/* Right panel */}
            <div className=" flex-1 w-full md:w-1/2 bg-white/5 rounded-2xl px-5 py-5 md:px-6 md:py-5 shadow-[0_18px_45px_rgba(0,0,0,0.4)]">
              <h3 className="text-white text-[18px] font-semibold mb-4">
                Why it helps?
              </h3>

              <ul className="space-y-[10px] text-[13px] md:text-[12px] text-white/70">
                <li className="flex items-start gap-2">
                  <span className="mt-[2px]">
                    <PolygonEnt />
                  </span>
                  <span>Collecting payment references manually is slow.</span>
                </li>

                <hr className="border-0 border-t border-white/10" />

                <li className="flex items-start gap-2">
                  <span className="mt-[2px]">
                    <PolygonEnt />
                  </span>
                  <span>
                    Businesses often don’t respond to traditional requests.
                  </span>
                </li>
                <hr className="border-0 border-t border-white/10" />
                <li className="flex items-start gap-2">
                  <span className="mt-[2px]">
                    <PolygonEnt />
                  </span>
                  <span>WhatsApp makes sharing payment feedback effortless.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentReferencesHubSection;
